/** Identity is assigned only when the coordinator starts a retained snapshot. */
export function applySubmissionIdentity(input, { feedbackId, version } = {}) {
  const id = feedbackId || input.feedbackId || (input.kind === 'incomplete' ? input.submissionId : null);
  const nextVersion = id || input.kind === 'incomplete' ? Math.max((version || 0) + 1, input.version || 1) : null;
  const headers = { ...input.headers, 'X-COMPLETED': input.kind === 'final' };
  const payload = { ...input.payload };

  delete headers['X-FID'];
  delete payload.version;
  if (id) headers['X-FID'] = id;
  if (nextVersion !== null) payload.version = nextVersion;

  return { ...input, feedbackId: id, version: nextVersion, headers, payload };
}

export function acceptedIdentity(record, body) {
  return {
    feedbackId: body?.id || record.feedbackId,
    version: Math.max(record.version || 0, Number.isInteger(body?.version) ? body.version : 0),
  };
}
